import { modelHelperModule } from './model-helper';
import * as StringUtils from '../utils/string-utils';

export const assessmentInvitationModelModule = angular
  .module('Q.models.assessment-invitation', [modelHelperModule])

  .factory('AssessmentInvitation', function (ModelHelper) {
    return ModelHelper.defineResource({
      name: 'AssessmentInvitation',
      endpoint: 'assessment_invitations',

      methods: {
        inviter() {
          const self = this;
          const workflow = self.invitedByWorkflowLabel;
          let inviter = '';
          if (workflow) {
            if (self.invitedByAssessmentTitle) {
              inviter = self.invitedByAssessmentTitle + ' - ';
            }
            inviter += workflow;
            if (!/workflow/i.test(workflow)) {
              inviter += ' Workflow';
            }
          } else if (self.inviterRole === 'staff') {
            inviter = 'Automated Invitation';
          } else if (self.inviterRole === 'api') {
            inviter = 'Automated Invitation - API';
          } else if (self.teamMember) {
            inviter = self.teamMember.nameOrEmail;
          }
          return inviter || '(Inviter Data Missing)';
        },
        isActive() {
          return this.state === 'active';
        },
        isAccepted() {
          return this.state === 'accepted';
        },
        isCanceled() {
          return this.state === 'cancelled';
        },
        isExpired() {
          return this.state === 'expired';
        },
        inviteLink() {
          return this.invitePath && StringUtils.absoluteUrl(this.invitePath);
        },
        invitePracticeLink() {
          return (
            this.invitePracticePath &&
            StringUtils.absoluteUrl(this.invitePracticePath)
          );
        },
        shouldCollapse(last) {
          const inv = this;
          return (
            (inv.isActive() || inv.isAccepted()) &&
            inv.state === last.state &&
            inv.teamMemberId === last.teamMemberId &&
            inv.action === last.action
          );
        },
      },

      relations: {
        belongsTo: {
          Assessment: {
            localField: 'assessment',
            localKey: 'assessmentId',
          },
          AssessmentResult: {
            localField: 'assessmentResult',
            localKey: 'assessmentResultId',
          },
          TeamCandidate: {
            localField: 'teamCandidate',
            localKey: 'teamCandidateId',
          },
          TeamMember: {
            localField: 'teamMember',
            localKey: 'teamMemberId',
          },
        },
      },

      meta: {
        saveExcludes: ['assessment', 'teamCandidate'],
        actionEndpoints: {
          cancel: { method: 'DELETE' },
          resend: { method: 'POST' },
          accept: { method: 'POST' },
        },
      },
    });
  });
